import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import MultiSelect from "../../../components/common/MultiSelect";
import { RequiredAsterisk } from "../../../components/professional/RequiredAsterisk";
import { convertStringToOptions } from "../../../utils/helpers";
import { licenseTypeOptions } from "../../../utils/professionalDropdownOptions";
import TextareaField from "./TextAreaField";

const QualificationsStep = ({ data, onChange, errors, dropDownOptions }) => {
  const {
    experienceLevelChoices,
    aircraftTypeChoices,
    visaRequirementsChoices,
    medicalClassChoices,
  } = dropDownOptions;
  const handleMultiSelect = (field, value) => {
    // const value = event.target.value;
    onChange(field, typeof value === "string" ? value.split(",") : value);
  };
  return (
    <Box component="form" noValidate>
      <Grid container spacing={3}>
        {/* Experience Level */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            select
            fullWidth
            label={
              <span>
                Experience Level <RequiredAsterisk />
              </span>
            }
            value={data.experience_level || ""}
            error={!!errors.experience_level}
            helperText={errors.experience_level}
            onChange={(e) => onChange("experience_level", e.target.value)}
          >
            {experienceLevelChoices.map((lvl) => (
              <MenuItem key={lvl.value} value={lvl.value}>
                {lvl.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Required license types Requirements */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <MultiSelect
            id="required_license_types"
            label="Required License Types"
            options={licenseTypeOptions}
            value={convertStringToOptions(
              data.required_license_types,
              licenseTypeOptions
            )}
            onChange={(value) => onChange("required_license_types", value)}
            limitTags={2}
            error={!!errors.required_license_types}
            helperText={errors.required_license_types}
            isArr={true}
          />
        </Grid>

        {/* Aircraft types */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <MultiSelect
            id="aircraft_type"
            label={<span>Aircraft types <RequiredAsterisk /></span>}
            options={aircraftTypeChoices}
            value={convertStringToOptions(
              data.aircraft_type,
              aircraftTypeChoices
            )}
            onChange={(value) => onChange("aircraft_type", value)}
            limitTags={3}
            error={!!errors.aircraft_type}
            helperText={errors.aircraft_type}
            isArr={true}
          />
        </Grid>

        {/* Flight Hours */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            type="number"
            label="Maximum Flying Hours"
            value={data.total_flying_hours_required || ""}
            onChange={(e) =>
              onChange("total_flying_hours_required", e.target.value)
            }
            error={!!errors.total_flying_hours_required}
            helperText={errors.total_flying_hours_required}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            type="number"
            label="Minimum Flight Hours"
            slotProps={{ htmlInput: { min: 0 } }}
            value={data.minimum_flight_hours || ""}
            onChange={(e) => onChange("minimum_flight_hours", e.target.value)}
            error={!!errors.minimum_flight_hours}
            helperText={errors.minimum_flight_hours}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            type="number"
            label="Minimum Pilot in Command Hours"
            slotProps={{ htmlInput: { min: 0 } }}
            value={data.minimum_pic_hours || ""}
            onChange={(e) => onChange("minimum_pic_hours", e.target.value)}
            error={!!errors.minimum_pic_hours}
            helperText={errors.minimum_pic_hours}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            type="number"
            label="Specific aircraft hours required"
            slotProps={{ htmlInput: { min: 0 } }}
            value={data.specific_aircraft_hours_required || ""}
            onChange={(e) =>
              onChange("specific_aircraft_hours_required", e.target.value)
            }
            error={!!errors.specific_aircraft_hours_required}
            helperText={errors.specific_aircraft_hours_required}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            type="number"
            label="Recency of experience months"
            slotProps={{ htmlInput: { min: 0 } }}
            value={data.recency_of_experience_months || ""}
            onChange={(e) =>
              onChange("recency_of_experience_months", e.target.value)
            }
            error={!!errors.recency_of_experience_months}
            helperText={errors.recency_of_experience_months}
          />
        </Grid>

        {/* Certificates and Requirements */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Medical Certification required"
            value={data.medical_certification_required || ""}
            onChange={(e) =>
              onChange("medical_certification_required", e.target.value)
            }
            error={!!errors.medical_certification_required}
            helperText={errors.medical_certification_required}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            select
            fullWidth
            label="Medical class"
            placeholder="Required medical class for this position"
            value={data.medical_class || ""}
            onChange={(e) => onChange("medical_class", e.target.value)}
            error={!!errors.medical_class}
            helperText={errors.medical_class}
          >
            {medicalClassChoices.map((q) => (
              <MenuItem key={q.value} value={q.value}>
                {q.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            select
            fullWidth
            label="Visa Requirements"
            value={data.visa_requirements || ""}
            onChange={(e) => onChange("visa_requirements", e.target.value)}
            error={!!errors.visa_requirements}
            helperText={errors.visa_requirements}
          >
            {visaRequirementsChoices.map((q) => (
              <MenuItem key={q.value} value={q.value}>
                {q.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Probation Period */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            type="number"
            fullWidth
            label="Probation Period in months"
            placeholder="6"
            slotProps={{ htmlInput: { min: 0 } }}
            value={data.probation_period_months}
            onChange={(e) =>
              onChange("probation_period_months", e.target.value)
            }
            error={!!errors.probation_period_months}
            helperText={errors.probation_period_months}
          />
        </Grid>

        {/* Background Check */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={data.background_check_required || false}
                onChange={(e) =>
                  onChange("background_check_required", e.target.checked)
                }
              />
            }
            label="Background Check Required"
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <TextareaField
            // error={errors.endorsements_required}
            label="Endorsements"
            name="endorsements_required"
            onChange={(e) =>
              handleMultiSelect("endorsements_required", e.target.value)
            }
            placeholder="Comma separated list of endorsements required for this position e.g: abc, def"
            value={data.endorsements_required}
            required={false}
            rows={3}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default QualificationsStep;
